import React, { useState, useEffect } from "react";
import "./UserDashboard.css";
import { Container, Nav, Button, Navbar, Row, Col, Card, Table, Dropdown } from "react-bootstrap";
import { MDBFooter, MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import Logo from "../src/Photos/eximtracfinallogo.png";
import { Link, useNavigate } from "react-router-dom";
import Account from "../src/Photos/Account.png";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import container from "../src/Photos/Container.png";

function UserDashboard() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const navigate = useNavigate();

    const [input, setData] = useState([]); // Ensure `input` starts as an empty array

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!token || !userId) {
            console.error("Token or User ID not found in localStorage");
            setData([]);
            return;
        }

        fetch(`https://api-ft5g.onrender.com/Get-data-for-user-side-enquiry-page-user-dashboard/${userId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then((docs) => {
                if (docs && docs.data) {
                    setData(docs.data);
                    console.log(docs.data);
                } else {
                    console.warn("Data property not found in response:", docs);
                    setData([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setData([]);
            });
    }, []); // Runs only on component mount


    const handleViewOrder = (orderId) => {
        // Store OrderID in localStorage
        localStorage.setItem("selectedOrderId", orderId);

        // Navigate to Order Details Page
        navigate(`/Enquiry/${orderId}`);
    };


    const [input2, setData2] = useState([]); // Ensure `input` starts as an empty array

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!token || !userId) {
            console.error("Token or User ID not found in localStorage");
            setData2([]);
            return;
        }

        fetch(`https://api-ft5g.onrender.com/Get-orders-data-user-side-user-dashboard/${userId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then((docs) => {
                if (docs && docs.data) {
                    setData2(docs.data);
                    console.log(docs.data);
                } else {
                    console.warn("Data property not found in response:", docs);
                    setData2([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setData2([]);
            });
    }, []); // Runs only on component mount


    const handleViewOrder2 = (orderId, userId) => {
        // Store OrderID in localStorage
        localStorage.setItem("selectedOrderId", orderId);

        // Navigate to Order Details Page
        navigate(`/Order/${orderId}/${userId}`);
    };


    const [isLoggedIn, setIsLoggedIn] = useState(false);
    //   const navigate = useNavigate();

    useEffect(() => {
        // Check if the user is logged in when the component mounts
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");
        setIsLoggedIn(!!(token && userId)); // Set `isLoggedIn` based on the existence of token and userId
    }, []);

    const handleLoginClick = () => {
        if (isLoggedIn) {
            alert("You are already logged in!"); // Show an alert if already logged in
        } else {
            navigate("/Login"); // Redirect to login page if not logged in
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("userId");
        localStorage.removeItem("token");
        console.log("User logged out and data removed from localStorage.");
        setIsLoggedIn(false);
        navigate("/Login"); // Redirect to login
    };


    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <p className="mt-3 logosidetext">Government Recognised Export House</p>
                        </Nav>

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/" className="navtext">Home</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/Aboutus" className="navtext">About Us</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/Products" className="navtext">Order Now</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/ContactUs" className="navtext">Contact Us</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/ProductCatalogue" className="navtext">Product Catalogue</Nav.Link>
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle
                                    className="scrollbtn2 p-0 mx-3 mt-1 responsiveview"
                                    id="dropdown-basic"
                                >
                                    <img
                                        src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleLoginClick}>Login</Dropdown.Item> {/* Login click handler */}
                                    {isLoggedIn && <Dropdown.Item href="/Profile">My Profile</Dropdown.Item>}
                                    {isLoggedIn && <Dropdown.Item href="/UserDashboard">Dashboard</Dropdown.Item>}
                                    {isLoggedIn && (
                                        <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>

                            {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0 mx-3 responsiveview">
                                            <Link to="/Profile">
                                                <img src={Account}
                                                    alt="account"
                                                    className="d-inline-block align-top"
                                                />
                                            </Link>
                                        </Button> */}

                            <Button onClick={scrollToTop} className="scrollbtn2 p-0 mx-3 responsiveview">
                                <Link to="/Addtocontainer">
                                    <img src={container}
                                        alt="container"
                                        className="d-inline-block align-top"
                                    />
                                </Link>
                            </Button>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle
                            className="scrollbtn2 p-0 me-3 mobileview"
                            id="dropdown-basic"
                        >
                            <img
                                src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleLoginClick}>Login</Dropdown.Item> {/* Login click handler */}
                            {isLoggedIn && <Dropdown.Item href="/Profile">My Profile</Dropdown.Item>}
                            {isLoggedIn && <Dropdown.Item href="/UserDashboard">Dashboard</Dropdown.Item>}
                            {isLoggedIn && (
                                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Button onClick={scrollToTop} className="scrollbtn2 p-0 mobileview">
                        <Link to="/Addtocontainer">
                            <img src={container}
                                alt="container"
                                className="d-inline-block align-top"
                            />
                        </Link>
                    </Button>
                </Container>
            </Navbar>

            {/* -----------------Navbar Complete---------------- */}

            <Container fluid>
                <Container fluid>
                    <Row>
                        <Col className="mt-3">
                            <Row>
                                <Col>
                                    <p className="enquiry">ENQUIRY</p>
                                </Col>

                                <Col className="text-end">
                                    <Link to="/EnquiryPage">
                                        <Button>See All Enquiries</Button>
                                    </Link>
                                </Col>
                            </Row>

                            <Card className="p-2">
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                Sr No.
                                            </th>

                                            <th className="">
                                                Order ID
                                            </th>

                                            <th>
                                                User ID
                                            </th>

                                            <th>
                                                Email ID
                                            </th>

                                            <th>
                                                Customer Name
                                            </th>

                                            <th>
                                                Company Name
                                            </th>

                                            <th>
                                                Enquiry Date
                                            </th>

                                            <th>
                                                View
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {input.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {index + 1}
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item.OrderID}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item.UserID}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item.EmailID}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item.FirstName} {item.LastName}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item.CompanyName}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{new Date(item.UploadDate).toLocaleDateString()}</p>
                                                </td>


                                                <td>
                                                    <Button
                                                        className="mt-1 dotbtn"
                                                        onClick={() => handleViewOrder(item.OrderID)}
                                                    >
                                                        View Enquiry / Quotations
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <Container fluid>
                    <Row>
                        <Col className="mt-3">
                            <Row>
                                <Col>
                                    <p className="orders">ORDERS</p>
                                </Col>

                                <Col className="text-end">
                                    <Link to="/OrderPage">
                                        <Button>
                                            See All Orders
                                        </Button>
                                    </Link>
                                </Col>
                            </Row>

                            <Card className="p-2">
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                Sr No.
                                            </th>

                                            <th className="">
                                                Order ID
                                            </th>

                                            <th>
                                                User ID
                                            </th>

                                            <th>
                                                Proforma Invoice Number
                                            </th>

                                            <th>
                                                Proforma Invoice Date
                                            </th>

                                            {/* <th>
                                                Company Name
                                            </th>

                                            <th>
                                                Enquiry Date
                                            </th> */}

                                            <th>
                                                View
                                            </th>

                                            <th>
                                                Deal Status
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {input2.map((item2, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {index + 1}
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item2.OrderID}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item2.UserID}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item2.ProformaInvoiceNumber}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{item2.ProformaInvoiceDate}</p>
                                                </td>

                                                {/* <td>
                                                    <p className="mt-2 ccn">{item2.CompanyName}</p>
                                                </td>

                                                <td>
                                                    <p className="mt-2 ccn">{new Date(item2.UploadDate).toLocaleString()}</p>
                                                </td> */}


                                                <td>
                                                    {/* <Button onClick={scrollToTop} className="mt-1 dotbtn">
                                                                <Link to="/Order" className="dotlink">
                                                                    View Order / Quotations
                                                                </Link>
                                                            </Button>s */}
                                                    <Button className="mt-1 dotbtn" onClick={() => handleViewOrder2(item2.OrderID, item2.UserID)}>View Order</Button>
                                                </td>

                                                <td>
                                                    {/* <Card className="pending text-center mt-2"> */}
                                                    {item2.ShippingStatus}
                                                    {/* </Card> */}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* ----------------FOOTER----------------- */}

                <MDBFooter bgColor='light' className='text-center text-lg-start text-muted pt-4'>
                    {/* <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>
                                        <div className='me-5 d-none d-lg-block'>
                                            <span>Get connected with us on social networks:</span>
                                        </div>
                
                                        <div>
                                            <Link to="#" className='me-4 text-reset'>
                                                <FaFacebook />
                                            </Link>
                
                                            <Link to="#" className='me-4 text-reset'>
                                                <MDBIcon color='secondary' fab icon='twitter' />
                                            </Link>
                
                                            <Link to="#" className='me-4 text-reset'>
                                                <MDBIcon color='secondary' fab icon='instagram' />
                                            </Link>
                
                                            <Link to="#" className='me-4 text-reset'>
                                                <MDBIcon color='secondary' fab icon='linkedin' />
                                            </Link>
                                        </div>
                                    </section> */}

                    <section className=''>
                        <MDBContainer className='text-center text-md-start mt-5'>
                            <MDBRow className='mt-3'>
                                <MDBCol md='3' lg='4' xl='3' className='mx-auto mb-4'>
                                    <h6 className='text-uppercase fw-bold mb-4 companyname'>
                                        {/* <MDBIcon color='secondary' icon='gem' className='me-3' /> */}
                                        Eximtrac
                                    </h6>
                                    <p>
                                        We are a certified Mumbai-based exporter, specializing in Indian groceries and FMCG products (food and non-food).
                                        With a vast portfolio of 200+ brands and new additions regularly, we source and deliver everything you need, consolidating all your requirements into one solution.
                                    </p>
                                </MDBCol>

                                <MDBCol md='2' lg='2' xl='2' className='mx-auto mb-4'>
                                    <h6 className='text-uppercase fw-bold mb-4 companyname'>Quick Links</h6>
                                    <p>
                                        <Button onClick={scrollToTop} className="foottextbtn p-0">
                                            <Link to="/" className='text-reset foottext'>
                                                Home
                                            </Link>
                                        </Button>
                                    </p>
                                    <p>
                                        <Button onClick={scrollToTop} className="foottextbtn p-0">
                                            <Link to="/Aboutus" className='text-reset foottext'>
                                                About Us
                                            </Link>
                                        </Button>
                                    </p>
                                    <p>
                                        <Button onClick={scrollToTop} className="foottextbtn p-0">
                                            <Link to="/Products" className='text-reset foottext'>
                                                Order Now
                                            </Link>
                                        </Button>
                                    </p>
                                    <p>
                                        <Button onClick={scrollToTop} className="foottextbtn p-0">
                                            <Link to="/ContactUs" className='text-reset foottext'>
                                                Contact Us
                                            </Link>
                                        </Button>
                                    </p>
                                </MDBCol>

                                <MDBCol md='3' lg='2' xl='2' className='mx-auto mb-4'>
                                    <h6 className='text-uppercase fw-bold mb-4 companyname'>OFFICE ADDRESS</h6>
                                    <p>
                                        Eximtrac<br />
                                        Shop No 2&3, Laxmi Apts, Behind Patel Nagar,
                                        M.G. Cross Road no 4, Kandivali West,
                                        Mumbai – 400067, India

                                    </p>
                                </MDBCol>

                                <MDBCol md='4' lg='3' xl='3' className='mx-auto mb-md-0 mb-4'>
                                    <h6 className='text-uppercase fw-bold mb-4 companyname'>CONTACT & EMAIL</h6>
                                    <p>
                                        {/* <MDBIcon color='secondary' icon='envelope' className='me-3' /> */}
                                        <div class="icon-bar">
                                            <a href="mailto:eximtrac@gmail.com" className="textdeco">
                                                <MdEmail className="me-2" /> eximtrac@gmail.com
                                            </a>
                                            <br />
                                            <a href="mailto:connect@eximtrac.com" className="textdeco">
                                                <MdEmail className="me-2 footerphone" /> connect@eximtrac.com
                                            </a>
                                        </div>
                                    </p>

                                    <p>
                                        {/* <MDBIcon color='secondary' icon='phone' className='me-3' /> + 01 234 567 88 */}
                                        <div>
                                            <a href="tel:9699268642" className="textdeco">
                                                <FaPhoneAlt className="me-2" /> +91-96992 68642
                                            </a>
                                            <br />
                                            <a href="tel:9029937080" className="textdeco">
                                                <FaPhoneAlt className="me-2 footerphone" /> +91-90299 37080
                                            </a>
                                        </div>
                                    </p>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </section>

                    <div className='text-center p-4 footerlastbgco'>
                        © 2024 Copyright:
                        <a className='text-reset fw-bold' href='Eximtrac'>
                            Eximtrac
                        </a>
                    </div>
                </MDBFooter>
            </Container >
        </>
    );
}

export default UserDashboard;